require('@fancyapps/fancybox');
import Headroom from 'headroom.js';
import 'slick-carousel/slick/slick.min.js';
var imagesLoaded = require('imagesloaded');
import objectFitImages from 'object-fit-images';
require('jquery-match-height/dist/jquery.matchHeight-min.js');
import Cookies from 'js-cookie';
require('jquery-doubletaptogo/dist/jquery.dcd.doubletaptogo.min.js');
require('reframe.js/dist/jquery.reframe.min.js');

export default {
  init() {
    // JavaScript to be fired on all pages
    var $hamburger = $('#menu-hamburger');
    $hamburger.on('click', function (e) {
      e.preventDefault();
      $hamburger.toggleClass('is-active');
    });

    var $jsoverlay = $('.js-off-canvas-overlay');
    $jsoverlay.on('click', function (e) {
      e.preventDefault();
      $hamburger.removeClass('is-active');
    });
    
    var headroomElement = document.querySelector('header');
    var headroomOptions = {
      // vertical offset in px before element is first unpinned
      offset : 500,
      // or you can specify offset individually for up/down scroll
/*       offset: {
          up: 100,
          down: 50
      }, */
      // scroll tolerance in px before state changes
      //tolerance : 0,
      // or you can specify tolerance individually for up/down scroll
      tolerance : {
          up : 5,
          down : 0,
      },
      // css classes to apply
      // element to listen to scroll events on, defaults to `window`
      //scroller : someElement,
      // callback when pinned, `this` is headroom object
/*       onPin : function() {},
      // callback when unpinned, `this` is headroom object
      onUnpin : function() {},
      // callback when above offset, `this` is headroom object
      onTop : function() {},
      // callback when below offset, `this` is headroom object
      onNotTop : function() {},
      // callback when at bottom of page, `this` is headroom object
      onBottom : function() {},
      // callback when moving away from bottom of page, `this` is headroom object
      onNotBottom : function() {}, */
  };
    // construct an instance of Headroom, passing the element
    var headroom  = new Headroom(headroomElement, headroomOptions);
    // initialise
    headroom.init();

    objectFitImages('.slide img');
    if ($('#top_slider .slide').length > 1) {

      $('#top_slider').on('init', function (event, slick) {


      });

      $('#top_slider').on('afterChange', function (event, slick, currentSlide, nextSlide) {

      });

      $('#top_slider').slick({
        dots: false,
        arrows: true,
        autoplay: true,
        accessibility: true,
        adaptiveHeight: false,
        infinite: true,
        fade: true,
        speed: 1200,
        pauseOnHover: false,
        waitForAnimate: false,
        nextArrow: '<span class="lnr lnr-chevron-right slide-arrow-right"></span>',
        prevArrow: '<span class="lnr lnr-chevron-left slide-arrow-left"></span>',
      });



    }
    else if ($('#top_slider .slide').length) {

      //for single-slide
      $('#top_slider').imagesLoaded(function () {
        $('#top_slider').addClass('slick-initialized');
      });



    }

    $('#top_slider').imagesLoaded().progress(function (instance, image) {

      var result = image.isLoaded ? 'loaded' : 'broken';
      if (result == 'loaded') {
        //console.log(image);
        $(image.img).parents('div').addClass('imageloaded');
      }

    });

    if ($('.galleryslider .slide').length > 1) {



      $('.galleryslider .slides').slick({
        dots: true,
        arrows: false,
        autoplay: true,
        accessibility: true,
        adaptiveHeight: true,
        infinite: true,
        fade: true,
        speed: 1200,
        pauseOnHover: false,
        waitForAnimate: false,
        nextArrow: '<span class="lnr lnr-chevron-right slide-arrow-right"></span>',
        prevArrow: '<span class="lnr lnr-chevron-left slide-arrow-left"></span>',
      });



    }
    
    $('.top-alert-bar').on('click', '.close-button', function(e) {
        e.preventDefault();
        $('.top-alert-bar').slideUp();
        Cookies.set('topAlertCookie', 'hide', { expires: 1 });
    });

    var topAlertCookie = Cookies.get('topAlertCookie');
    
    if(typeof topAlertCookie !== 'undefined') {
        $('.top-alert-bar').slideUp();
    }
    else {
        $('.top-alert-bar').slideDown();
    }

    $('.woocommerce-product-gallery--with-images').slick({
      dots: true,
      arrows: false,
      autoplay: false,
      accessibility: true,
      adaptiveHeight: true,
      infinite: true,
      fade: true,
      speed: 1200,
      pauseOnHover: false,
      waitForAnimate: false,
    });
    

    $('.entry-content .elementor-widget-text-editor iframe').reframe();

    $( '.search-toggle' ).on('click', function(e) {
      e.preventDefault();

      $( '#top-searchbar' ).slideToggle( 'slow', function() {
        // Animation complete.
      });
    });

  },
  finalize() {
    // JavaScript to be fired on all pages, after page specific JS is fired
  },
};



// WEBPACK FOOTER //
// ./scripts/routes/common.js